var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":_vm.complejidadProyecto.descripcion,"subtitle":"Complejidad de proyecto","back-to":"/complejidadesProyecto"}}),_c('formulario',{attrs:{"complejidad-proyecto":_vm.complejidadProyecto},on:{"submit":_vm.actualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }